import { sectionRoutes } from '../helpers';

export const TELEPHONY_ROUTES = [
  ...sectionRoutes({
    meta: { adminTab: 'Telephony' },
    tabKey: 'telephonyTab',
    routes: [
      ['telephony', 'AdminTelephony', 'phone_book'],
      ['telephony/phone-book', 'AdminTelephonyPhoneBook', 'phone_book'],
      ['telephony/call-types', 'AdminTelephonyCallTypes', 'call_types'],
      ['telephony/participant-roles', 'AdminTelephonyParticipantRoles', 'participant_roles'],
      ['telephony/phone-numbers', 'AdminTelephonyPhoneNumbers', 'phone_numbers'],
    ],
  }),
  { path: 'telephony/address-book', redirect: { name: 'AdminTelephonyPhoneBook' } },
];
